import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MainContainer, ClassesContainer, ClassesContent, ClassesContentContainer, FixedWrapper } from './style';
import { ClassCard } from '../../Components/ClassCard';
import { getId } from '../../../Utils';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { Loading } from '../WithLoading/Loading';
import { EmptyState } from '../WithEmptyState/EmptyState';
import { CheckInClassEmptyState } from '../../Components/BannerEmptyStats/BannerEmptyStats';
import { LeftHeader } from './LeftHeader';
import ClassCheckInDisplay from './ClassCheckInDisplay';
import CalendarPaginator from './CalendarPaginator';
import { ClassesActionCreators } from '../../../Store/ActionCreators/ClassesActionCreators';
import { UserActionCreators } from '../../../Store/ActionCreators/UserActionCreators';
import { getCurrentFormattedDate } from '../../../Utils/timeConvertorHelper';
import { timeFormats } from '../../../Constants/timeFormats';

class CheckIn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            classSelected: {},
        };
    }

    componentDidMount() {
        this.props.getCurrentUser();
        this.props.getClassesByDate(null, null, getCurrentFormattedDate(timeFormats.SERVER_DATE_TYPE));
    }

    selectClass = classSelected => {
        this.setState({ classSelected });
    };

    clearSelection = () => {
        this.setState({ classSelected: {} });
    };

    changeDate = dateFilter => {
        this.props.getClassesByDate(null, null, dateFilter);
    };

    render() {
        const { classes, classesLoading, user } = this.props;
        const { classSelected } = this.state;
        const emptyClasses = classes.length === 0;

        return (
            <MainContainer>
                <ClassesContainer>
                    <LeftHeader {...user} />
                    <ClassesContentContainer>
                        <CalendarPaginator onChangeDate={this.changeDate} />
                        <Loading isLoading={classesLoading}>
                            <EmptyState isEmpty={emptyClasses} emptyState={CheckInClassEmptyState}>
                                <FixedWrapper>
                                    <ClassesContent>
                                        <div>
                                            {classes.map((_class, index) => {
                                                const isCurrentClassSelected = classSelected.id === _class.id;

                                                return (
                                                    <div
                                                        key={index}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => this.selectClass(_class)}
                                                    >
                                                        <ClassCard isSelected={isCurrentClassSelected} {..._class} />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </ClassesContent>
                                </FixedWrapper>
                            </EmptyState>
                        </Loading>
                    </ClassesContentContainer>
                </ClassesContainer>
                <ClassCheckInDisplay {...classSelected} onClear={this.clearSelection} />
            </MainContainer>
        );
    }
}

const mapStateToProps = ({
    classes: {
        classes,
        statuses: { classesLoading },
    },
    user: { currentUser },
}) => ({
    classes,
    classesLoading,
    user: currentUser,
});

const mapDispatchToProps = dispatch => {
    const PROFILE_ID = getId(handleLoginService.getUserId());

    return {
        getClasses(offsetId, offsetDate) {
            dispatch(ClassesActionCreators.getClassesRequest(PROFILE_ID, offsetId, offsetDate));
        },
        getClassesByDate(offsetId, offsetDate, dateFilter) {
            dispatch(ClassesActionCreators.getClassesByDateRequest(PROFILE_ID, offsetId, offsetDate, dateFilter));
        },
        getCurrentUser() {
            dispatch(UserActionCreators.getAuthenticatedUserRequest());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CheckIn);



// WEBPACK FOOTER //
// ./src/UI/Containers/CheckIn/index.js